import { debounce } from './debounce';
import { validateEmail } from './validateEmail';
const handleEmailValidation = async e => {
  const newEmail = e.target.value;

  // Perform email validation and return bool "isValid?"
  return newEmail.length >= 3 ? validateEmail(newEmail) : true;
};
export const debouncedHandleEmailValidation = debounce(handleEmailValidation, 300);